import { useState } from 'react';
import { Box, ButtonBase, Popover, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { COLOR_OPTIONS } from 'utils/colorOptions';

export const ColorDotPicker = ({ color, onChange, disabledColor, label = 'Change color' }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <>
            <Tooltip title={label}>
                <ButtonBase
                    aria-label={label}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    sx={{ width: 12, height: 12, flexShrink: 0, borderRadius: '2px', backgroundColor: color, outline: '1px solid rgba(0,0,0,0.15)', outlineOffset: '2px' }}
                />
            </Tooltip>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ display: 'flex', gap: 1, p: 1.5 }}>
                    {COLOR_OPTIONS.map((option) => (
                        <Tooltip key={option.hex} title={option.hex === disabledColor ? `${option.name} (used by the other range)` : option.name}>
                            <span><ButtonBase
                                aria-label={option.name}
                                disabled={option.hex === disabledColor}
                                onClick={() => {
                                    onChange(option.hex);
                                    setAnchorEl(null);
                                }}
                                sx={{ width: 28, height: 28, '&.Mui-disabled': { opacity: 0.25 }, borderRadius: '50%', backgroundColor: option.hex, color: '#fff', border: option.hex === color ? '2px solid #fff' : '2px solid transparent', boxShadow: option.hex === color ? `0 0 0 2px ${option.hex}` : 'none' }}
                            >
                                {option.hex === color && <CheckIcon sx={{ fontSize: 16 }} />}
                            </ButtonBase></span>
                        </Tooltip>
                    ))}
                </Box>
            </Popover>
        </>
    );
};
